import { ParameterList } from 'src/components/molecules';

export function isRulePropsPopulated(rule: ParameterList) {
  const ruleProperties: (keyof ParameterList)[] = [
    'site',
    'department',
    'country',
    'systemRoles',
    'relationshipToCompany',
    'submissionMode',
    'anonymous',
    'reportedCategory',
    'userMetaData.division',
    'userMetaData.organization',
    'Call.organisationHotlineNumber',
    'coiCategory',
    'questionnaireId',
  ];

  return !ruleProperties.every((prop) => !rule[prop]);
}
